import { GeneralModel } from './general.model';

export class GeneralInfo extends GeneralModel {
    companyName: string;
    companyPhone: string;
    logoPath: string;
    email: string;
    address: string;
    hotline: string;
    countBranch: number;
    countCustomer: number;
    countExperence: number;
    countTruct: number;
    linkInfo: string;
}
